import React from "react";
import { FaReact, FaNodeJs } from "react-icons/fa";
import {
  SiCss3,
  SiHtml5,
  SiTypescript,
  SiMongodb,
  SiRedux,
  SiExpress,
  SiVercel,
} from "react-icons/si";
import { IoLogoJavascript } from "react-icons/io5";
import nexamart from "../Assets/nexamart.png";
import lms from "../Assets/lms.png";
import "./Projects.css";
import { Link } from "react-router-dom";

function Projects() {
  return (
    <section id="projects" className="section projects">
      <h2 className="section__title about_project">Projects</h2>

      <div className="projects__grid">
        {/* ----- Project 1 ----- */}
        <div className="project">
          <img src={nexamart} alt="NexaMart" />

          <h3 className="about_project">NexaMart</h3>

          <ul className="project__stack">
            <li className="project__stack-item" id="stacks">
              <SiHtml5 size={30} />
              <IoLogoJavascript size={30} />
              <SiCss3 size={30} />
              <FaReact size={30} />
              <SiRedux size={30} />
              <SiExpress size={30} />
              <SiMongodb size={30} />
              <FaNodeJs size={30} />
              <SiVercel size={30} />
            </li>
          </ul>

          <div id="b">
            <a
              href="https://nexa-mart-psi.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span type="button" className="btn btn--outline">
                Watch Live
              </span>
            </a>

            <Link
              to="/Project-Details/NexaMart"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span type="button" className="btn btn--outline">
                Description
              </span>
            </Link>
          </div>
        </div>

        {/* ----- Project 2 ----- */}
        <div className="project">
          <img src={lms} alt="NinjaCode" />

          <h3 className="about_project">ELearning-LMS</h3>

          <ul className="project__stack">
            <li className="project__stack-item" id="stacks">
              <SiHtml5 size={30} />
              <SiTypescript size={30} />
              <SiCss3 size={30} />
              <FaReact size={30} />
              <SiExpress size={30} />
              <SiMongodb size={30} />
              <FaNodeJs size={30} />
              <SiVercel size={30} />
            </li>
          </ul>

          <div id="b">
            <a
              href="https://e-learning-lms-xi.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span type="button" className="btn btn--outline">
                Watch Live
              </span>
            </a>

            <a href="/Project-Details/lms" target="_blank">
              <span type="button" className="btn btn--outline">
                Description
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Projects;
